module.exports = __webpack_public_path__ + "img/icon3.a3e1feb9.png";